const en = {
  common: {
    ok: 'OK',
    cancel: 'Cancel',
    location: 'Location',
    date: 'Date',
    temp: 'Temp',
    bus: 'Bus',
    yes: 'Yes',
    Y: 'Y',
    no: 'No',
    confirm: 'Confirm',
    edit: 'Edit',
    view: 'View',
    unAllocatedMessage: 'No bookings are unallocated',
    saveChanges: 'Save Changes',
    from: 'From',
    to: 'To',
    bkgName: 'BKG Name',
    bkgTitle: 'M/F/Ch:TOTAL',
    addAnother: 'Add another',
    logout: 'Logout',
    darkTheme: 'Dark Theme',
    lightTheme: 'Light Theme',
    myAvailability: 'My Availability',
    paxExceedError:
      'Some pax values exceed the total allowed. Please update them before submitting.',
    allocatePaxUpdate:
      'Nothing is updated , Please update/allocate the pax then save.',
    feedBack: 'Feedback',
  },
  greetings: {
    hello: 'Hello, {{name}}!',
  },
  loginScreen: {
    signinToSkybiz: 'Sign In to Skybiz',
    errorMessage: {
      invalidCredentials: 'Invalid Username or Password.',
      usernameRequired: 'Username is required.',
      passwordRequired: 'Password is required.',
    },
    forgetPassword: 'Forget Password',
  },
  allocation: {
    dropOff: 'Dropoff',
    Pickup: 'Pickup',
    id: 'ID',
    comment: 'Comment',
    tour: 'Trip',
    agent: 'Agent',
    pax: 'Pax',
    flight: 'Flight',
  },
  busAllocation: {
    bus: 'Bus',
    luggage: "L'ge",
    balloon: 'Balloon',
    allocated: 'Allocated',
    successMessage: {
      allocationSave: 'Driver Allocation details saved successfully',
    },
    errorMessage: {
      busAllocation: 'Please select at least one bus to be allocated',
    },
    tableColumn: {
      id: 'Id',
      name: 'Name',
      pickup: 'Pickup',
      dropoff: 'Drop Off',
      tour: 'Trip',
      comment: 'Comment',
      luggage: "L'ge",
      agent: 'Agent',
      balloon: 'Balloon',
      allocated: 'Al',
      flights: 'Flt',
      pax: 'Pax',
    },
    incorrectAllocation: 'Pax are unallocated',
  },
  dropOffScreen: {
    busAllocationHeading: 'Drop Off Bus Allocation',
  },
  pickupScreen: {
    busAllocationHeading: 'Pickup Bus Allocation',
  },
  flightAllocation: {
    flightAllocation: 'Flight Allocation',
    percentageOfUnAllocated: '% Pax are unallocated',
    flights: 'Flights',
    weight: 'Weight',
    male: 'Male',
    female: 'Female',
    child: 'Child',
    allocated: 'Allocated',
    earlyReturn: 'Early Return',
    noData: 'No data for this date',
    errorMessage: {
      FlightAllocation: 'Please select at least one flight to be allocated',
      selectFlight: 'No flight selected for booking',
    },
    successMessage: {
      allocationSave: 'Flight Allocation details saved successfully',
    },
    flight: 'F',
    tableColumn: {
      id: 'Id',
      pickup: 'Pickup',
      dropoff: 'Drop Off',
      trip: 'Trip',
      comment: 'Comment',
      er: 'ER',
      name: 'Name',
      agent: 'Agent',
      allocated: 'Al',
      flight: 'Flt',
      pax: 'Pax',
      m: 'M',
      f: 'F',
      ch: 'Ch',
      mfch: 'M\\F\\Ch',
    },
    card: {
      pax: 'Pax',
      weight: 'Weight',
      cancelled: 'Cancelled',
    },
  },
  viewBookings: {
    bkgId: 'BKG ID',
    refNo: 'Ref. No.',
    agent: 'Agent',
    viewBooking: 'View Bookings',
    Pretravel: 'Pretravel',
    passed: 'Passed',
    sent: 'Sent',
    notSent: 'Not Sent',
    status: 'Status',
    booked: 'Booked',
    confirmed: 'Confirmed',
    rebook: 'Rebook',
    paid: 'Paid',
    voucher: 'Voucher',
    cxl: 'Cxl',
    person: 'Person',
    assoAgent: 'Asso Agent',
    marketSource: 'Market Source',
    adult: 'Adult',
    child: 'Child',
    infant: 'Infant',
    time: 'Time',
    male: 'Male',
    female: 'Female',
    d1OpsChecklist: 'D1 Ops Checklist',
    tableColumn: {
      id: 'Id',
      date: 'Date',
      status: 'Status',
      name: 'Name',
      pretravel: 'Pretravel',
      cxl: 'Cxl',
      adult: 'Ad',
      child: 'Ch',
      infant: 'Inf',
      trip: 'Trip',
      pickup: 'Pickup',
      dropOff: 'Drop Off',
      agent: 'Agent',
      person: 'Person',
      assocAgent: 'Assoc Agent',
      marketSource: 'Market Source',
      d1OpsChecklist: 'D1 Ops Checklist',
      time: 'Time',
    },
  },
  operation: {
    driverAddedSuccessfully: 'Driver is added successfully',
    driverUpdatedSuccessfully: 'Driver is updated successfully',
    tempAddedSuccessfully: 'Temp is added successfully ',
    commonError: 'Something went wrong',
    staffAddedSuccessfully: 'Staff added successfully ',
    googleDriverAdded: 'URL added successfully',
    dailyOperation: 'Daily Operations',
    dutyManager: 'Duty Manager',
    allAllocation: 'Duty Staff',
    pilotInCommand: 'Duty Pilot',
    reservation: 'Reservations',
    photos: 'Photos',
    flightRequirements: 'Flight Requirements',
    temp: 'Temp',
    pic: 'PIC',
    total: 'Max',
    flight: 'Flights',
    pickupMax: 'Pickup Max',
    dropOffMax: 'Drop off Max',
    busMax: 'Bus Max',
    earlyReturn: 'Early Return',
    dataIsNotAvailable: 'No data is available',
    bookingActioned: 'Booking is actioned',
    balloonCount: 'Balloons Count CNS+GC',
    pax: 'Pax',
    filled: 'Filled',
    launchTime: 'Launch Time',
    landTime: 'Land Time',
    fuel: 'Fuel',
    flightDetailsUpdatedSuccessfully: 'Flight details updated successfully',
    flightDetailsUpdatedSuccessfullyNotUpdated: 'Flight details not updated',
    countryPaxCount: {
      adult: 'Adult',
      child: 'Child',
      infant: 'Infant',
      errorMessage: {
        notFound: 'Passenger count for the country not found.',
      },
    },
    flightDetails: {
      am: 'AM',
      timeBlankSpace: '--:--',
      weight: 'Weight',
      pilotHours: 'Pilot Hrs',
      basketTTIS: 'Basket TTIS',
      envelopeTTIS: 'Envelope TTIS',
      cxld: 'CXLD',
      blankSpace: '--',
    },
    weatherLabel: {
      winds: 'Winds',
      '1000': '1000',
      '2000': '2000',
      '3000': '3000',
      '5000': '5000',
      swsd: 'SWSD',
      pressure: 'Pressure',
      errorMessage: {
        notFound: 'Weather details not found.',
      },
    },
    weatherTravelStatus: {
      statusUpdatedSuccessfully: 'Travel status is updated successfully',
    },
    loadTemp: 'Load Temp.',
  },
  operationCheckList: {
    id: 'ID',
    title: 'Type Title',
    description: 'Description',
    tour: 'Trip',
    agent: 'Agent',
    pickup: 'PickUp',
    dropOff: 'DropOff',
    actionedBy: 'Actioned by',
    actionedDate: 'Actioned Date',
    adult: 'Adult',
    child: 'Child',
    infant: 'Infant',
    actioned: 'Actioned',
  },
  driver: {
    driverName: 'Driver Name',
    driverNameValidation: 'Please select a driver.',
    driverSelection: 'Select Driver',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceHolder: 'Enter Phone Number',
    phoneNumberValidation: 'Enter Phone Number',
    route: 'Route',
    routeValidation: 'Route is required.',
    selectRoute: 'Select Route',
    bus: 'Bus',
    busValidation: 'Bus selection is required.',
    selectBus: 'Select Bus',
    balloon: 'Balloon',
    balloonValidation: 'Balloon selection is required.',
    selectBalloon: 'Select Balloon',
    startTime: 'Start Time',
    endTime: 'End Time',
    startTimeValidation: 'Start Time is required.',
    startTimePlaceholder: 'Enter Start Time',
    fuel: 'Fuel (L)',
    fuelPlaceholder: 'Enter Fuel',
    fuelValidation: 'Fuel is required.',
    startOdo: 'Start Odo',
    startOdoPlaceholder: 'Enter Start Odo',
    startOdoValidation: 'Start Odo is required.',
    startOdoMessage: 'Please enter a valid number.',
    fuelMessage: 'Please enter a valid number (e.g., 12.5)',
    endOdo: 'End Odo',
    endOdoPlaceHolder: 'Enter End Odo',
    endOdoValidation: "'End Odo is required.'",
    endOdoMessage: 'Please enter a valid number.',
    bat: 'BAT',
    batPlaceholder: 'Enter BAT',
    batValidation: 'BAT is required.',
    deleteStaff: 'Staff is deleted successfully',
  },
  operationCommon: {
    need: 'Need',
    kkd: "KK'D",
    preCheck: 'Pre Check',
  },
  crew: {
    crewUpdated: 'Crew is updated successfully',
    crewAdded: 'Crew is added successfully',
    crewName: 'Crew Name',
    crewSelect: 'Select Crew',
    qualification: 'Qualification',
    vehicle: 'Vehicle',
    vehicleValidation: 'Please select a vehicle',
    vehicleSelection: 'Select a vehicle',
    phoneNumber: 'Phone Number',
    phoneNumberPlaceholder: 'Enter Phone Number',
    phoneNumberValidation: 'Phone number is required',
  },
  pilot: {
    pilotUpdated: 'Pilot is updated successfully',
    pilotAdded: 'Pilot is added successfully',
    pilotName: 'Pilot Name',
    selectPilot: 'Select Pilot',
    pilotValidation: 'Pilot is required',
    balloonCapacity: 'Balloon Capacity',
    balloonCapacityValidation: 'Balloon capacity is required',
    actualWeight: 'Actual Weight',
  },
  hTTPErrors: {
    500: 'Something went wrong. Please try again later.',
    400: 'The server could not understand the request. Please check your input.',
    401: 'You need to log in to access this resource.',
    403: 'You do not have permission to access this resource.',
    404: 'The requested resource could not be found.',
    408: 'The server took too long to respond. Please try again.',
    504: 'The server did not get a response in time. Please try again later',
  },
  deleteConfirmation: {
    youWantToDelete: 'Are you sure you want to delete this',
  },
  ofl: {
    ofl: 'OFL',
    oflSuccessMessage: 'OFL is updated successfully',
  },
  passengerManifest: {
    PassengerManifest: 'Passenger Manifest',
    portDuglasLocation: 'Hot Air Balloon Cairns & Port Douglas',
    goldCostLocation: 'Hot Air Balloon Brisbane & GoldCost',
    Pilot: 'Pilot',
    flightTime: 'Flight Time',
    haRef: ' HA Ref',
    country: 'Country',
    meetingPoint: 'Hotel or Meeting Point',
    notOnThisFlight: 'Not on this Flight',
    dataNotAvailable: 'No data available',
    winds: 'Winds',
    meter: 'Atmospheric Readings',
    launchSite: 'Launch Site',
    landingSite: 'Landing Site',
  },
  breakfast: {
    breakfastPax: 'Breakfast Pax',
    exclBreakfastPax: 'Excl Breakfast Pax',
    cateringComments: 'Catering Comments',
    noCateringComments: 'No catering comments yet',
  },
  paymentBreakup: {
    pax: 'Pax',
    total: 'Total $',
    count: 'Count',
  },
  flightForm: {
    commentsInput: 'Detailed Cancellation Comments',
    flight: 'Flight',
    capacity: 'Capacity',
    reason: 'Reason',
    cancelFlightMessage:
      'Are you sure you want to cancel the flight for Balloon {{flightName}}?',
    formTitle: 'Cancellation For Balloon OHA',
    formSubTitle: 'Hot Air Balloon Cairns and Port Douglas',
  },
  weatherAndTravel: {
    formTitle: 'Weather And Travel status - {{date}}',
    heading: 'Heading',
    expectedTemp: 'Expected Temp',
    ofl: 'OFL',
    forcastOrStatus: 'Forecast or Status',
    information: 'Information',
    note: 'Note',
    lastupdate: 'Last Updates',
    weatherAndTravel: 'Weather and Travel Status',
  },
  myAvalabilityCalender: {
    title: 'View My Availability - {{name}}',
    availabilityStatus: 'Availability Status',
    subtitle:
      'Select the Status from the list below and mark it on the calendar.',
    staffMissing: 'Staff ID is missing.',
    selectDate: 'Please select at least one date.',
    emptyStatus: 'Please select a status.',
    updateStatus: 'Availability status updated successfully!',
    failedToFetch: 'Failed to fetch availability status.',
    failedToUpdate: 'Failed to Upadte availability status.',
  },
  generalComment: {
    generalComment: 'General Comments',
    generalCommentAdd: 'General Comments added successfully!',
    generalCommentUpdate: 'General Comments added successfully!',
    generalCommentDelete: 'General comments delete successfully!',
    generalCommentError: 'Error adding comment',
  },
  compliances: {
    upcomingStaff: 'Upcoming Staff Compliances',
    upcomingVehicle: 'Upcoming Vehicle & Trailer Compliances',
    upcomingAirCraft: 'Upcoming Air Craft Compliances',
    pilotHours: 'Pilot Hours 23/04/2025',
    driverSummary: 'Driver Summary 13/03/2025',
    onlineUser: 'User Online:',
    passwordExpire: 'Password expires in',
    lastLogin: 'Last Login:',
    commonTableHeader: {
      name: 'Name',
      compliance: 'Compliance',
      category: 'Category',
      status: 'Status',
      allocatedTo: 'Allocated to',
      vehicle: 'Vehicle',
      pilotHours: 'Pilot Hours',
      driverSummary: 'Driver Summary',
      restsDays: 'Rests (days)',
      sevenDaysHrs: '7 Days (hrs)',
      fourteenDaysHrs: '14 Days (hrs)',
      restDaysInFourteen: 'Rest Days in 14 Total (Min 4)',
      conSecMinTwo: 'Consec .(Min 2)',
      kkdDays: "KK'D Days in 14 Total(Max 10)",
      conSecMax: 'Consec. (Max 6)',
      kkdDate: "KK'D",
    },
  },
  complianceNote: {
    noData: 'Looks like there’s no data to display right now.',
  },
};

export type Translations = typeof en;

export default en;
